<template>
  <aside :class="$style.container">
    <nav>
      <ul>
        <left-menu-item
          route="console"
          label="Console"
          icon="dashboard"
          exact
        />
      </ul>
      <div>
        <h2 :class="$style.subtitle">My Services</h2>
        <ul>
          <left-menu-item route="nodes" label="Nodes" icon="nodes" />
          <stake-link v-if="enableConsoleV2Redirect" />
        </ul>
      </div>
      <div>
        <h2 :class="$style.subtitle">Account</h2>
        <ul>
          <left-menu-item route="billing" label="Billing" icon="billing" />
          <left-menu-item route="iam" label="IAM" icon="key" />
        </ul>
      </div>
    </nav>
    <base-icon
      name="logo"
      :class="$style.logo"
      themeSize="xx-large"
      opacity="0.2"
      alt
    />
  </aside>
</template>

<script>
import LeftMenuItem from '@/components/LeftMenuItem'
import StakeLink from '@/components/StakeLink'
import config from '@/services/config'

export default {
  components: { LeftMenuItem, StakeLink },
  data: () => ({
    enableConsoleV2Redirect: config.enableConsoleV2Redirect || false
  }),
  name: 'LeftMenu'
}
</script>

<style lang="scss" module>
.container {
  padding-top: spacing(3);
  background: $color-light;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  box-shadow: $shadow-small;
  overflow-y: auto;

  ul {
    list-style-type: none;
    padding: 0;
    margin: 0;

    li + li {
      margin-top: spacing(2);
    }
  }
}

.subtitle {
  font-size: $size-xx-small;
  line-height: 2;
  font-weight: $weight-medium;
  color: $color-copy;
  text-transform: uppercase;
  letter-spacing: 2px;
  padding: 0 spacing(4);
  margin: spacing(3) 0 spacing(1) 0;
  background-image: linear-gradient(
    to left,
    rgba(0, 0, 0, 0.1),
    rgba(0, 0, 0, 0)
  );
}

.logo {
  align-self: flex-start;
  margin: spacing(4);
  flex-shrink: 0;
}
</style>
